// Deduplicate an array
const unique = <T,>(input: T[]) => [...Array.from(new Set(input))];

export default unique;
